/**
 * 消息发送状态
 */
'use strict';

import {h, Component} from 'preact';
import './msg-status.scss';

export default class MsgStatus extends Component{
	constructor(props){
		super(props);
	}

	render({status, ...props}, state){
		let _style = 'status__' + status;
		let text = status === 'err' ? '!': '';

		return (
			<div class={['status',_style].join(' ')}
				 onClick={this.props.onErrClick}>
				{text}
			</div>
		)
	}
}



/** WEBPACK FOOTER **
 ** ./components/message/msg-status/msg-status.jsx
 **/